import React from "react";
import { Card, Button, Image } from "react-bootstrap";

const VisitorRecord = (props) => {
  const handleConfirm = () => {
    console.log(props.visitor);
    props.confirm(props.visitor);
  };
  return (
    <div className="container mt-2">
      <Card>
        <Card.Body>
          <div className="row">
            <Image thumbnail src={props.visitor.image}></Image>
            <div className="col">
              <div className="row">
                <h4>{`${props.visitor.name} ${
                  props.visitor.surname ? props.visitor.surname : ""
                }`}</h4>
                <h4>{`(${props.visitor.paymentOption.toUpperCase()})`}</h4>
              </div>
              <div className="col col-md-auto"></div>
            </div>
            <Button
              disabled={props.visitor.state === "confirmed"}
              onClick={handleConfirm}
            >
              {props.visitor.state !== "confirmed" ? "Confirm" : "Confirmed"}
            </Button>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default VisitorRecord;
